import SVG from "react-inlinesvg";
import React from "react";

export const IconAndTitleLeftNav = (props) => {
  return (
    <div
      className="ml-2 "
      style={{
        width: props?.mobile ? "unset" : "65%",
        height: props?.mobile ? "unset" : "50px",
      }}
      align="center"
    >
      <div className="navigation-icon-main">
        <SVG src={props?.icon} className="navigation-icon" alt="Icon" />
      </div>
      <div
        style={{
          color: "black",
          position: "relative",
          zIndex: "9",
        }}
        className="f9-400 text-left-navigation-main-title"
      >
        {props?.mobile ? "" : props?.title}
      </div>
    </div>
  );
};
